import React from 'react';
import Title from './Title';

const DataCardContent = ({
  title,
  subtitle,
  tooltip,
  labsBadgeDescription,
  children,
}) => (
  <div className="DataCard-labReport">
    <Title
      title={title}
      tooltip={tooltip}
      subtitle={subtitle}
      labsBadgeDescription={labsBadgeDescription}
    />
    {children}
  </div>
);

export default DataCardContent;
